module.exports = "/images/icon_post-review.svg?95a63a4c80421aeb17df1898e64779e2";